/* SELHYAN 31/10/2026 — Video courte sur certaines cartes produit (collections + recherche), facon Cult Gaia.
   - La photo reste affichee (poster = image du produit, pas de saut de mise en page, element LCP = image).
   - La video n'est chargee et lue que lorsqu'au moins 50 % de la carte est visible ; pause hors ecran.
   - Rien n'est charge si l'utilisateur prefere moins d'animations, si Save-Data est actif ou en 2G.
   - Vue galerie (9 par rangee, bureau) : photo uniquement.
   - Plage de lecture optionnelle (data-start / data-end) pour ne jamais montrer certains plans. */
const STYLE_ID = 'sln-card-video-style';
if (!document.getElementById(STYLE_ID)) {
  const s = document.createElement('style');
  s.id = STYLE_ID;
  s.textContent = `
    .product-card__media:has(.sln-card-video) { position: relative; }
    .sln-card-video { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; opacity: 0; transition: opacity .6s ease; pointer-events: none; background: transparent; z-index: 1; }
    .sln-card-video.is-playing { opacity: 1 !important; }
    @media (prefers-reduced-motion: reduce) { .sln-card-video { display: none !important; } }
    @media screen and (min-width: 1000px) { .product-list[collection-desktop-layout="compact"] .sln-card-video { display: none !important; } }
  `;
  document.head.appendChild(s);
}

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
const lowData = () => !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')));
const disabled = () => reduceMotion.matches || lowData();

const pickSrc = (v) => {
  // Mobile / petites cartes : rendu 720p maximum ; bureau grandes cartes : 1080p si disponible.
  const w = v.getBoundingClientRect().width * (window.devicePixelRatio || 1);
  return (window.innerWidth >= 1000 && w > 420 && v.dataset.srcHd) ? v.dataset.srcHd : v.dataset.srcSd;
};

const isShown = (v) => v.isConnected && getComputedStyle(v).display !== 'none' && v.offsetParent !== null;

const play = (v) => {
  if (disabled() || !isShown(v) || document.hidden) return;
  if (!v.getAttribute('src')) {
    v.src = pickSrc(v);
    const start = parseFloat(v.dataset.start || '0') || 0;
    if (start > 0) v.addEventListener('loadedmetadata', () => { try { v.currentTime = start; } catch (e) {} }, { once: true });
  }
  const p = v.play();
  if (p && p.catch) p.catch(() => {});
};

const pause = (v) => { if (!v.paused) v.pause(); };

const watchWindow = (v) => {
  const start = parseFloat(v.dataset.start || '0') || 0;
  const end = parseFloat(v.dataset.end || '0') || 0;
  if (!end && !start) return; // lecture complete en boucle (attribut loop)
  const check = () => {
    if ((end && v.currentTime >= end) || v.currentTime < start - 0.05) v.currentTime = start;
  };
  if ('requestVideoFrameCallback' in HTMLVideoElement.prototype) {
    const tick = () => { check(); v.requestVideoFrameCallback(tick); };
    v.requestVideoFrameCallback(tick);
  }
  v.addEventListener('timeupdate', check);
  v.addEventListener('ended', () => { v.currentTime = start; v.play().catch(() => {}); });
};

const io = new IntersectionObserver((entries) => {
  entries.forEach((e) => {
    const v = e.target;
    if (e.isIntersecting && e.intersectionRatio >= 0.5) play(v); else pause(v);
  });
}, { threshold: [0, 0.5] });

// Jamais deux videos cote a cote : dans une meme grille, une video de la liste est ignoree (photo seule)
// si une autre video (deja retenue, ou video native de carte, avant ou apres) se trouve a 1, 2 ou 4 cartes
// (voisine horizontale ou verticale en 2 ou 4 colonnes).
const tooClose = (v) => {
  const card = v.closest('product-card');
  const list = card && card.closest('.product-list');
  if (!list) return false;
  const cards = [...list.querySelectorAll('product-card')];
  const i = cards.indexOf(card);
  return [1, 2, 4].some((d) => [cards[i - d], cards[i + d]].some((c, k) => {
    if (!c) return false;
    if (c.querySelector('video:not(.sln-card-video)')) return true; // video native de la carte
    const pv = c.querySelector('video.sln-card-video');
    return k === 0 && pv && pv.dataset.slnInit === '1';
  }));
};

const init = (v) => {
  if (v.dataset.slnInit) return;
  if (tooClose(v)) { v.dataset.slnInit = 'skip'; v.remove(); return; }
  v.dataset.slnInit = '1';
  v.addEventListener('error', () => {
    if (v.dataset.srcHd && v.getAttribute('src') !== v.dataset.srcHd) { v.src = v.dataset.srcHd; v.play().catch(() => {}); }
  });
  v.muted = true; v.defaultMuted = true; v.playsInline = true;
  v.addEventListener('playing', () => v.classList.add('is-playing'));
  watchWindow(v);
  io.observe(v);
};

const scan = (root) => root.querySelectorAll && root.querySelectorAll('video.sln-card-video').forEach(init);
scan(document);

new MutationObserver((muts) => {
  muts.forEach((m) => {
    m.addedNodes.forEach((n) => { if (n.nodeType === 1) { if (n.matches?.('video.sln-card-video')) init(n); else scan(n); } });
    if (m.type === 'attributes') {
      // changement de vue (galerie / 4 / 2) : on relance l'observation pour (re)lire ou mettre en pause
      m.target.querySelectorAll('video.sln-card-video').forEach((v) => { pause(v); io.unobserve(v); io.observe(v); });
    }
  });
}).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['collection-desktop-layout', 'collection-mobile-layout'] });

document.addEventListener('visibilitychange', () => {
  document.querySelectorAll('video.sln-card-video').forEach((v) => {
    if (document.hidden) pause(v); else { io.unobserve(v); io.observe(v); }
  });
});

const stopAll = () => { if (disabled()) document.querySelectorAll('video.sln-card-video').forEach(pause); };
reduceMotion.addEventListener?.('change', stopAll);
conn?.addEventListener?.('change', stopAll);
